import { LoadingStates, consoleEvents } from '@pb/utils'
import { createReducer } from 'redux-act'

import actions from './actions'
import initialState from './initialState'
import { MembershipInfoState } from './types'

const fetchMembershipInfoStart = (state): MembershipInfoState => ({
  ...state,
  membershipLoadingState: LoadingStates.Loading,
})

const fetchMembershipInfoSuccess = (state, membershipDetail): MembershipInfoState => ({
  ...state,
  membershipDetail,
  membershipLoadingState: LoadingStates.LoadedSuccess,
})

const fetchMembershipInfoFail = (state, error): MembershipInfoState => {
  consoleEvents.error(`Failed to load membership details`, error)

  return {
    ...state,
    membershipDetail: {},
    membershipLoadingState: LoadingStates.LoadedFail,
  }
}
const reducer = createReducer((on) => {
  on(actions.fetchMembershipInfoStart, fetchMembershipInfoStart)
  on(actions.fetchMembershipInfoSuccess, fetchMembershipInfoSuccess)
  on(actions.fetchMembershipInfoFail, fetchMembershipInfoFail)
}, initialState)

export default reducer
